import { useFlags } from 'launchdarkly-react-client-sdk';

import { KIOSK_CONCIERGE_ROLLOUT_FLAG } from '@dutchie/common/utils/concierge-rollout';

type DispensaryWithKioskConciergeSetting =
  | {
      id?: string | null;
      storeSettings?: {
        enableKioskConcierge?: boolean | null;
      } | null;
    }
  | null
  | undefined;

/**
 * Kiosk concierge is on only when the LD rollout flag and the super-admin
 * `enableKioskConcierge` setting are both exactly `true` (fail closed). Kiosk
 * never inherits the web `enableConcierge` flag. This is the live gate;
 * ConciergePage latches the flag itself.
 */
export function useIsKioskConciergeEnabled(dispensary: DispensaryWithKioskConciergeSetting): boolean {
  const flags = useFlags();
  return isKioskConciergeSettingOn(dispensary) && flags[KIOSK_CONCIERGE_ROLLOUT_FLAG] === true;
}

export function isKioskConciergeSettingOn(dispensary: DispensaryWithKioskConciergeSetting): boolean {
  return dispensary?.storeSettings?.enableKioskConcierge === true;
}
